import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-dealers',
  imports: [RouterLink],
  templateUrl: './dealers.component.html',
  styleUrl: './dealers.component.css',
})
export class DealersComponent implements OnInit {
  constructor(private seoService: SeoService) { }

  ngOnInit() {
    this.setMetaData();
  }

  private setMetaData(): void {
    const title = 'Join ONLY USED TESLA Dealer Network - Amplify Your Tesla Inventory Exposure | Only Used Tesla';
    const description = "Become a part of ONLY USED TESLA's exclusive dealer network. Expand your reach, increase sales, and accelerate your business growth. Discover the advantages of our targeted Tesla-specific advertising platform today.";
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png'; // You can change this image if needed
    const url = 'https://onlyusedtesla.com/dealers';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }
}
